import React from 'react';

const Panel = ({ title, subtitle, right, children, className = '', tone = 'default', livePulse = false }) => {
  const toneBorder = {
    default: 'border-white/10',
    alert: 'border-[#D71921]/60',
    warn: 'border-[#FFB800]/50',
    ok: 'border-[#00C27A]/40',
  }[tone];

  return (
    <div className={`relative flex flex-col bg-[#0A0A0A] border ${toneBorder} ${className}`}>
      {livePulse && (
        <div className="absolute top-3 right-3 flex items-center gap-2 z-10">
          <span className="w-1.5 h-1.5 rounded-full bg-[#D71921] animate-pulse" />
          <span className="font-mono-tech text-[8px] uppercase tracking-[0.2em] text-[#D71921]">
            Live
          </span>
        </div>
      )}
      {(title || right) && (
        <div className="flex items-center justify-between px-4 py-3 border-b border-white/5 flex-shrink-0">
          <div>
            {title && (
              <div className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-neutral-400">
                {title}
              </div>
            )}
            {subtitle && (
              <div className="font-mono-tech text-[9px] uppercase tracking-[0.2em] text-neutral-600 mt-1">
                {subtitle}
              </div>
            )}
          </div>
          {right && <div className="flex items-center gap-2">{right}</div>}
        </div>
      )}
      <div className="flex-1 min-h-0 overflow-hidden">{children}</div>
    </div>
  );
};

export default Panel;
